import { useMemo } from 'react';

const parameterPattern = /{{([^}]+)}}/g;

export default function useTopicTemplate(template, context){
	const matcher = useMemo(() => {
		return new RegExp(
			template
				.replace(/\//g, '\\/')
				.replace(parameterPattern, '(?<$1>[^/]+)')
		);
	}, [template]);

	const topic = useMemo(() => {
		if ([
			template,
			context,
		].some(v => v === undefined)) {
			return;
		}
		return template.replace(parameterPattern,(_match, parameterName) => context[parameterName]);
	}, [ context, template ]);

	return [topic, matcher];
}
